import { TRUST_ENTITY_NAMES_NUMBER } from 'constants/loanApplication';

export const EMPTY_GROUPS_CONFIG = { groups: [] };
export const VALIDATION_TOAST_DURATION = 2_500;

export const TRUST_ENTITY_TYPES = ['trustee', 'settlor', 'beneficiary'];
export const REQUIRED_TRUST_ENTITY_TYPES = ['trustee', 'settlor'];

export const CLOSING_INFORMATION_SECTIONS = new Set([
  'scheduling-information',
  'closing-funding-dates',
  'funding-information',
]);

export const LOCK_GATED_CLOSING_SECTIONS = new Set([
  'closing-funding-dates',
  'funding-information',
]);

const HIDDEN_FUNDING_FORM_FIELDS = [
  'feeProviderLocationId',
  'companyStreet',
  'companyCity',
  'companyState',
  'companyZipCode',
  'city',
  'state',
];

const HIDDEN_TITLE_HOLDER_FORM_FIELDS = [
  'trustee1BorrowerId',
  'trustee2BorrowerId',
  'trustee3BorrowerId',
  'trustee4BorrowerId',
  'settlor1BorrowerId',
  'settlor2BorrowerId',
  'settlor3BorrowerId',
  'settlor4BorrowerId',
];

const HIDDEN_COMPANY_FORM_FIELDS = [
  'titleAttendantCompanyLocationId',
  'escrowAttendantCompanyLocationId',
  'sellerAttorneyAttendantCompanyLocationId',
  'buyerAttorneyAttendantCompanyLocationId',
  'mhBrokerAttendantCompanyLocationId',
  'mhDealerAttendantCompanyLocationId',
  'mhInvestorAttendantCompanyLocationId',
];

export const ALL_HIDDEN_FORM_FIELDS = [
  ...HIDDEN_FUNDING_FORM_FIELDS,
  ...HIDDEN_TITLE_HOLDER_FORM_FIELDS,
  ...HIDDEN_COMPANY_FORM_FIELDS,
];

export const TRUST_FIELD_NAMES = [
  'trustType',
  'trustEstablishedDate',
  'trustName',
  'trustEstablishedState',
  ...TRUST_ENTITY_TYPES.flatMap(prefix =>
    Array.from({ length: TRUST_ENTITY_NAMES_NUMBER }).flatMap((__, i) => {
      const order = i + 1;
      const keys = [`${prefix}${order}`];

      if (prefix !== 'beneficiary') {
        keys.push(`${prefix}${order}BorrowerId`);
      }

      if (prefix === 'trustee') {
        keys.push(`${prefix}${order}IsOwner`);
      }

      return keys;
    }),
  ),
];

export const FundingInformationFieldId = {
  WAREHOUSE_BANK_ID: 'fundingInfoWarehouseBankId',
  COMMITMENT_NUMBER: 'commitmentNumber',
  TYPE: 'type',
  WIRE_AMOUNT: 'fundingInfoWireAmount',
  WAREHOUSE_FUNDING_ORDERED: 'warehouseFundingOrdered',
  WIRE_POSTED_DATE: 'wirePostedDate',
  CURTAILMENT: 'curtailment',
  WIRE_COMMENTS: 'wireComments',
  FUNDING_CONFIRMATION_NUMBER: 'fundingConfirmationNumber',
};

export const WireToInformationFieldId = {
  FEE_PROVIDER_ID: 'feeProviderId',
  COMPANY_NAME: 'companyName',
  FEE_PROVIDER_ADDRESS: 'closingAgentFeeProviderAddress',
  BANK: 'bank',
  CITY: 'city',
  STATE: 'state',
  ABA_NUMBER: 'closingAgentABANumber',
  ACCOUNT_NUMBER: 'closingAgentAccountNumber',
  REFERENCE_NUMBER: 'referenceNumber',
  CONTACT: 'closingAgentContact',
  WAREHOUSE_BANK_ID: 'wireToInfoWarehouseBankId',
  WIRE_NUMBER: 'wireNumber',
  FED_REFERENCE_NUMBER: 'fedReferenceNumber',
  WIRE_AMOUNT: 'wireToInfoWireAmount',
  ADVANCE_AMOUNT_PERCENT: 'advanceAmountPercent',
  ADVANCE_AMOUNT: 'advanceAmount',
  ADD_ADVANCE_AMOUNT: 'addAdvanceAmount',
  FURTHER_CREDIT_ABA_NUMBER: 'furtherCreditToABANumber',
  FURTHER_CREDIT_ACCOUNT_NUMBER: 'furtherCreditToAccountNumber',
  FURTHER_CREDIT_CONTACT: 'furtherCreditToContact',
};

export const TitleHolderFieldId = {
  MANNER_HELD: 'mannerHeld',
  VESTING_DESCRIPTION: 'vestingDescription',
  VESTING_TYPE_ID: 'vestingTypeId',
  BPL_COMPANY_NAME: 'bplCompanyName',
};

export const TrustFieldId = {
  TYPE: 'trustType',
  ESTABLISHED_DATE: 'trustEstablishedDate',
  NAME: 'trustName',
  ESTABLISHED_STATE: 'trustEstablishedState',
};

export const SchedulingFieldId = {
  ANTICIPATED_CLOSING_DATE: 'anticipatedClosingDate',
  FIRST_CLOSE_AT: 'firstCloseAt',
  CLOSE_AT: 'closeAt',
  LOCATION: 'location',
};

export const TitleInstructionsFieldId = {
  SPECIAL_ENDORSEMENT: 'specialEndorsement',
};

export const ClosingFundingDatesFormFieldId = {
  INTEREST_CREDIT_NOTE_DATE: 'interestCreditNoteDate',
  INTEREST_CREDIT_RESCISSION_DATE: 'interestCreditRescissionDate',
  INTEREST_CREDIT_FUNDING_DATE: 'interestCreditFundingDate',
  INTEREST_CREDIT_DISBURSEMENT_DATE: 'interestCreditDisbursementDate',
  INTEREST_CREDIT_FIRST_PAYMENT_DATE: 'interestCreditFirstPaymentDate',
  APPROVAL_DATE: 'approvalDate',
  APPROVAL_EXPIRATION_DATE: 'approvalExpirationDate',
  MATURITY_DATE: 'maturityDate',
  IS_MATURITY_DATE_SET_MANUALLY: 'isMaturityDateSetManually',
};

export const PREPAID_INTEREST_CREDIT_FORM_FIELD_IDS = [
  ClosingFundingDatesFormFieldId.INTEREST_CREDIT_NOTE_DATE,
  ClosingFundingDatesFormFieldId.INTEREST_CREDIT_RESCISSION_DATE,
  ClosingFundingDatesFormFieldId.INTEREST_CREDIT_FUNDING_DATE,
  ClosingFundingDatesFormFieldId.INTEREST_CREDIT_DISBURSEMENT_DATE,
  ClosingFundingDatesFormFieldId.INTEREST_CREDIT_FIRST_PAYMENT_DATE,
];
